module.exports = __webpack_public_path__ + "static/img/12.29b675b.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/3/2/5/zh/12.png
// module id = /CKJ
// module chunks = 0